import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import DOMPurify from "dompurify";
import Loader from "../../../components/Loader/Loader";
import PageShell from "../../../components/layout/PageShell";
import PageHead from "../../../components/layout/PageHead";
import "../../../components/common/css/campaignview.scss";

const Row = ({ k, v }) => (
  <div className="detailItem" style={{ flexBasis: "62%" }}>
    <span className="itemKey">{k}</span>
    <span className="itemValue">{v}</span>
  </div>
);

const CareersView = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("accessToken");
  const { id } = useParams();

  const getDataById = async () => {
    try {
      setLoading(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API}admin/get-joblisting-byid`,
        headers: { "x-access-token": token },
        data: { id },
      });
      setData((response.data.data && response.data.data[0]) || null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: error?.response?.data?.message,
        timerProgressBar: true,
        icon: "error",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
    }
  };

  useEffect(() => {
    getDataById();
  }, [id]);

  return (
    <PageShell>
      <PageHead title="Job opening" />
      <div className="single">
        <Loader isLoading={loading} />
        <div className="singleContainer">
          <div className="top">
            <div className="left">
              <div className="title-topSection">
                <h1 className="title">Job Opening</h1>
              </div>
              <div className="item">
                <div className="details profile-info">
                  <Row k="Title:" v={data?.title} />
                  <Row k="Location:" v={data?.location} />
                  <Row k="Employment Type:" v={data?.employmentType} />
                  <Row k="Experience:" v={data?.experience} />
                  <Row k="Contact Email:" v={data?.email} />
                  <Row k="Date Posted:" v={data?.datePosted} />
                  <Row k="Valid Through:" v={data?.validThrough || "Not set"} />
                  <Row
                    k="Status:"
                    v={data?.status == 1 ? "Active" : "Inactive"}
                  />
                  <div className="detailItem" style={{ flexBasis: "62%" }}>
                    <span className="itemKey">Description:</span>
                    <span
                      className="itemValue"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.description || ""),
                      }}
                    />
                  </div>
                  <div className="detailItem" style={{ flexBasis: "62%" }}>
                    <span className="itemKey">Applicants:</span>
                    <span className="itemValue">
                      <Link to="/careers/applicants">View applicants</Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default CareersView;
